import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Firm from '../../entities/firm';
export function deleteFirm(firm: Firm, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = firm.id;}
const _work = workingSet();




firm.status = 'D';
firm.addedOn = newHRTimestamp();
firm.addedBy = getCurrentUserId();
firm.importSource = targetImportSource;
firm.importId = mergeId;
store.dispatch(Actions.FirmActions.removeFirmQueue(firm));
}


